import React from "react";

export const BlueTickIcon = ({ className = "w-4 h-4 flex-shrink-0" }) => (
  <svg
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10" cy="10" r="10" fill="#3479F7" />
    <path
      d="M5.5 10.5L8.5 13.5L14.5 7"
      stroke="white"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GreenCheckIcon = ({ className = "w-[18px] h-[18px] flex-shrink-0" }) => (
  <svg
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10" cy="10" r="9" stroke="#12B76A" strokeWidth="1.8" />
    <path
      d="M6 10.5L8.5 13L14 7.5"
      stroke="#12B76A"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EllipseDotIcon = ({ className = "w-1.5 h-1.5 flex-shrink-0 mt-1" }) => (
  <svg
    className={className}
    viewBox="0 0 6 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="3" cy="3" r="3" fill="#3479F7" />
  </svg>
);
